module.exports = __webpack_public_path__ + "img/1485160542.bcaf1d94.jpg";